/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */
import React from 'react';
import { Flex, FlexProps, Image, Text } from '@getgo/chameleon-chakra-ui';
import { Button } from '../Button/Button';

interface Props extends FlexProps {
  author: string;
  buttonText: string;
  logo: string;
  price: string;
  storeText: string;
  title: string;
  link: string;
}

export const SmartBanner: React.FC<Props> = (props) => {
  const { author, buttonText, logo, price, storeText, title, link, ...rest } =
    props;
  return (
    <Flex
      justifyContent='space-between'
      bg='white'
      px={5}
      width='100%'
      {...rest}
    >
      <Flex alignItems='center'>
        <Image src={logo} alt={title} objectFit='cover' height='54px' mr='3' />
        <Flex direction='column' mb={1}>
          <Text fontSize='md' lineHeight='1.5' textColor={'black'}>
            {title}
          </Text>
          <Text fontSize='sm' lineHeight='1.1'>
            {author}
          </Text>
          <Text fontSize='sm' lineHeight='1.1'>
            {price} - {storeText}
          </Text>
        </Flex>
      </Flex>
      <Button size='sm' minWidth={24} isExternalLink={true} link={link} my={5}>
        {buttonText}
      </Button>
    </Flex>
  );
};
